<template>
  <Widget height="auto" width="400px">
    <div class="row">
      <div class="col-12">
        <h3>Stopwatch</h3>
        <StopWatch />
      </div>
      <div class="col-12 mt-4">
        <h3>Timer</h3>
        <AlarmTimer />
      </div>
    </div>
  </Widget>
</template>

<script>
import Widget from '../Widget.vue';
import StopWatch from './StopWatch.vue';3
import AlarmTimer from './AlarmTimer.vue';

export default {
  components: { StopWatch, AlarmTimer, Widget }
}
</script>